import { ChangeDetectionStrategy, Component, OnInit, AfterViewInit, inject, PLATFORM_ID } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { Store } from '@ngxs/store';
import { VERSION } from 'src/app/core/version';
import { GoogleAnalyticsService } from './core/services/google-analytics.service';
import { SeoService } from './core/services/seo.service';
import { AuthState } from './core/states/auth.state';
import { SnitcherService } from './core/services/snitcher.service';
import { StructuredDataComponent } from './layout/structured-data/structured-data.component';
import { MatIconRegistry } from '@angular/material/icon';
import { RollbarService } from './core/services/rollbar.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [StructuredDataComponent, RouterOutlet, RouterModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit, AfterViewInit {
  private platformId = inject(PLATFORM_ID);

  constructor(
    private seo: SeoService,
    private googleAnalytics: GoogleAnalyticsService,
    private snitcherService: SnitcherService,
    private store: Store,
    private iconRegistry: MatIconRegistry,
    private rollbar: RollbarService
  ) {
    if (isPlatformBrowser(this.platformId)) {
      console.log(`%c version: ${VERSION}`, 'background: #222; color: #bada55');
    }
    this.iconRegistry.setDefaultFontSetClass('material-icons-outlined');
  }

  ngOnInit() {
    this.googleAnalytics.enableTracking();
    this.rollbar.trackUser();
    this.snitcherService.enableTracking();

    // Adds all SEO data to HTML. SEO data is defined in the router module.
    this.seo.addSeoData();

    if (isPlatformBrowser(this.platformId)) {
      // Keep a lightweight, non-sensitive cookie in sync so the prerendered '/' page
      // can redirect signed-in visitors server-side, before Angular even loads (see server.ts).
      this.store.select(AuthState.isAuthenticated).subscribe((isAuthenticated) => {
        document.cookie = isAuthenticated
          ? 'mk_auth=1; path=/; max-age=2592000; samesite=lax'
          : 'mk_auth=1; path=/; max-age=0';
      });
    }
  }

  ngAfterViewInit() {}
}
